import { useState } from "react";
import { Area, Btn } from "./kit";

export const NoteForm = ({ onSubmit, placeholder = "Add a private note (internal only)", label = "Add note", testid = "note" }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (!text.trim()) return;
    setBusy(true);
    const ok = await onSubmit(text.trim());
    setBusy(false);
    if (ok !== false) setText("");
  };
  return (
    <div className="space-y-2">
      <Area value={text} onChange={setText} rows={3} placeholder={placeholder} testid={`${testid}-input`} />
      <Btn onClick={go} disabled={busy || !text.trim()} data-testid={`${testid}-submit`}>{label}</Btn>
    </div>
  );
};
